import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CasMultiRowTable } from 'src/compass/shared/components';
import { ICasMultiRowTable } from 'src/compass/shared/components/CasMultiRow/CasMultiRowTable';

export function useAsOfTableReplaceData(name: string) {
  const asOfDate = useWatch({ name: 'asOf.asOfDate' });

  const [replaceData, setReplaceData] = useState();
  const { getValues } = useFormContext();
  useEffect(() => {
    setReplaceData(getValues(name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asOfDate]);

  return replaceData;
}

export default function CasAsOfMultiRowTable(props: ICasMultiRowTable) {
  /*
        Because useFieldArray doesn't respond to external changes, trigger
        reload when asOf.asOfDate changes

        Note: CME Schedules handles separately
    */

  const { name } = props;
  const replaceData = useAsOfTableReplaceData(name);

  return <CasMultiRowTable {...props} replaceData={replaceData} />;
}
